import { BooleanTags } from "../../components/common/registerUtils";

export const useTransactionMonitoring = () => {
  const tableColumns = () => [
    {
      id: "merchant_name",
      header: "Merchant Name",
      filter: {},
    },
  ];

  //   const tableData = (data: any) => [
  //     ...data?.map((item: any) => {
  //       return {
  //         ...item,
  //         merchant_name: item?.merchant_name,
  //       };
  //     }),
  //   ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Merchant Service Access Details",
          fields: {
            merchant_Id: item?.merchant_Id,
            service_code: item?.service_code,
            is_active: <BooleanTags status={item?.is_active} />,
            api_acess: <BooleanTags status={item?.api_acess} />,
            web_acess: <BooleanTags status={item?.web_acess} />,
            mobile_acess: <BooleanTags status={item?.mobile_acess} />,
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    // tableData,
    viewData,
  };
};
